import { render, staticRenderFns } from "./WorkpostScanProductsPage.vue?vue&type=template&id=41b190ba"
import script from "./WorkpostScanProductsPage.vue?vue&type=script&lang=js"
export * from "./WorkpostScanProductsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports